<template>
  <div class="ai-chatbot-iframe-container">
    <iframe
      :key="src"
      v-if="!hasError"
      ref="iframe"
      :src="src"
      @load="onLoad"
      @error="onError"
      title="AI Chatbot Iframe"
    ></iframe>

    <component
      v-if="hasError"
      :is="errorComponent"
      @refresh="refresh"
    />
  </div>
</template>

<script>
import utils from '@/util'

export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    errorComponent: {
      type: [Object, String],
      default: null,
    },
  },

  data() {
    return {
      hasError: false,
      loadTimeoutAbortController: null,
    }
  },

  mounted() {
    // Check for immediate offline state
    if (!navigator.onLine) {
      this.onError()
      return
    }

    // Start timeout without blocking mounting
    this.startLoadTimeout()
  },

  beforeDestroy() {
    this.clearLoadTimeout()
  },

  methods: {
    async startLoadTimeout() {
      this.loadTimeoutAbortController = new AbortController()
      try {
        await utils.sleep(10000) // 10 second timeout
        if (!this.loadTimeoutAbortController.signal.aborted && !this.hasError) {
          this.onError()
        }
      } catch (error) {
        // Timeout was aborted, ignore
      }
    },

    clearLoadTimeout() {
      if (this.loadTimeoutAbortController) {
        this.loadTimeoutAbortController.abort()
        this.loadTimeoutAbortController = null
      }
    },

    onLoad() {
      // Clear timeout on successful load
      this.clearLoadTimeout()
      this.hasError = false
      this.$emit('onIframeReady')
    },

    onError() {
      // Clear timeout on error
      this.clearLoadTimeout()
      this.hasError = true
    },

    refresh() {
      // Check for offline state before refresh
      if (!navigator.onLine) {
        this.hasError = true
        return
      }

      this.hasError = false
      // Force iframe reload by updating the src
      if (this.$refs.iframe) {
        this.$refs.iframe.src = this.src
      }

      // Reset timeout for the refresh attempt
      this.startLoadTimeout()
    },
  },
}
</script>

<style scoped>
.ai-chatbot-iframe-container {
  width: 100%;
  height: 100%;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
